import { NgModule } from '@angular/core';
import { SharedModule } from '../_shared/shared.module';
import { LoaderComponent } from './components/loader/loader.component';

@NgModule({
  declarations: [],
  imports: [SharedModule, LoaderComponent],
  exports: [LoaderComponent],
})
export class CoreModule {}
